import { useEffect, useCallback, useMemo } from 'react';

import _, { isEmpty } from 'lodash';

import { useFetchLocationsCount } from './useFetchLocationsCount';

import { isV2PermissionsEnabled } from '../../../helpers/featureFlags/isV2PermissionsEnabled';
import { getUserRegions } from '../../../helpers/getUserRegions';
import { DEFAULT_REGIONS_SHORT } from '../helpers/regions';

export const useProviderLocationsSearch = ({
  finalData,
  formattedaddressVal,
  issearchProviderLocationsClick,
  preSearchRequestTransactionsObjectRef,
  isProviderInventoryManager,
  providerName,
  providerNameRbac,
  setIsEmptySearchValue,
  setIssearchProviderLocationsClick,
  setProviderName,
  setSearchRequestObject,
  teamType,
  totalCount,
  userData,
  tableSearchValue,
  pageSize,
  isEditDeleteSuccessCB,
  preSearchRequestObjectRef,
  searchRequestObject,
  setIsEmptyResponse,
  setPage,
  setResponseData,
  setTotalCount,
  sortField,
  sortDirection,
}) => {
  const regions = useMemo(
    () => (isV2PermissionsEnabled() ? getUserRegions() : DEFAULT_REGIONS_SHORT),
    [],
  );

  const { fetchLocationsCount } = useFetchLocationsCount({
    isEditDeleteSuccessCB,
    preSearchRequestObjectRef,
    preSearchRequestTransactionsObjectRef,
    searchRequestObject,
    setIsEmptyResponse,
    setPage,
    setResponseData,
    setTotalCount,
    totalCount,
    sortField,
    sortDirection,
    pageSize,
  });
  const searchProviderLocations = useCallback(() => {
    if (issearchProviderLocationsClick) return;

    const searchCheckBoxObj = {
      region: [],
      country: [],
      state: [],
      city: [],
    };

    const addressPartIndexMap = Object.keys(searchCheckBoxObj);

    setIssearchProviderLocationsClick(true);
    setIsEmptySearchValue(false);

    if (finalData && !!finalData.length) {
      const searchData = finalData.map((value) => value.bread);

      searchData.forEach((searchVal) => {
        const nodeArr = searchVal?.split('>');

        if (!nodeArr) return;

        nodeArr.forEach((node, index) => {
          const partName = addressPartIndexMap[index];
          const value = node?.trim();

          if (searchCheckBoxObj[partName].indexOf(value) === -1) {
            searchCheckBoxObj[partName].push(value);
          }
        });
      });
    }

    const reqObj = {};

    if (providerName) {
      reqObj.providerName = providerName.trim();
    }

    if (formattedaddressVal) {
      reqObj.providerAddress = formattedaddressVal.trim();
    }

    if (tableSearchValue) {
      reqObj.search = tableSearchValue.trim();
    }

    Object.keys(searchCheckBoxObj).forEach((key) => {
      if (searchCheckBoxObj[key].length) {
        reqObj[key] = Array.from(new Set(searchCheckBoxObj[key])).join('|').trim();
      }
    });

    if (!reqObj.region && (providerName || formattedaddressVal) && regions.length) {
      reqObj.region = Array.from(new Set(regions)).join('|').trim();
    }

    if (Object.keys(reqObj).length) {
      setSearchRequestObject(reqObj);
      fetchLocationsCount(reqObj, false, pageSize);
    } else {
      setIsEmptySearchValue(true);
      setSearchRequestObject({});
      preSearchRequestTransactionsObjectRef.current = '';
    }

    setTimeout(() => {
      setIssearchProviderLocationsClick(false);
    }, 0);
  }, [
    finalData,
    formattedaddressVal,
    issearchProviderLocationsClick,
    preSearchRequestTransactionsObjectRef,
    providerName,
    providerNameRbac,
    setIsEmptySearchValue,
    setIssearchProviderLocationsClick,
    setSearchRequestObject,
    tableSearchValue,
    regions,
    pageSize,
    fetchLocationsCount,
  ]);

  useEffect(() => {
    if (userData && userData['Team Name'] && teamType == 'Provider' && !isV2PermissionsEnabled()) {
      setProviderName(userData['Team Name']);
      if (providerName && !totalCount) searchProviderLocations();
    }

    if (isProviderInventoryManager) {
      setProviderName(providerNameRbac);
      if (providerName && !totalCount) searchProviderLocations();
    }
  }, [searchProviderLocations, userData, teamType, providerName, setProviderName, totalCount]);

  return { searchProviderLocations, fetchLocationsCount };
};
